import { PerformerEntity } from './performer.entity';

export class UserPerformerEntity extends PerformerEntity {
  userType: string; // 固定用户还是变量参与者
  constructor(id?: string, name?: string, type?: string) {
    super(id,name,type);
  }
}
